var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.525,
    height: 98.525,
    viewBox: "0 0 98.525 98.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "y9lOwP.tif",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24697",
    "data-name": "Group 24697",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24696",
    "data-name": "Group 24696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32573",
    "data-name": "Path 32573",
    d: "M84.374,385.487V286.962H182.9v98.525Zm43.667-20.053h-3.3v3.371h3.305q0,1.746-.008,3.491H121.01v-6.755h-3.225v13.552h3.187l.313-3.158H124.4c.123,1.151.232,2.165.34,3.178h16.961l.427-3.2,3.116-.283.407-3.181h3.127l.338,3.183,3.221.355c.085,1.157.155,2.1.228,3.082h23.941v-3.326h-6.574v-3.322l3.118-.234c.115-1.158.215-2.173.319-3.22l3.148-.213V362.06l-3.527-.2.081.085.275-3.3,3.206-.329V344.771l-3.623-.682.046.057.405-2.967,3.109-.374v-6.849h-6.668c-.081-1.231-.143-2.181-.223-3.384h-6.641l-.3-3.309-3.353-.3c.089-1.167.162-2.132.226-3.107q4.99.023,9.989.038c.131,1.006.262,2.011.4,3.085h3.332c-.115-1.25-.215-2.333-.306-3.408h3.519v-3.195h-3.1c-.127,1.178-.239,2.214-.351,3.249l-3.547.326c.1-1.159.2-2.318.3-3.537H159.292l.314,3.522-3.6-.28v10.3l.077-.085-3.491.328c-.1,1.081-.2,2.095-.3,3.147h-6.649v-6.629l3.166-.278.291-3.162,3.188-.331V320.2H142.109V309.554h6.617V299.094h-6.7l-.294-3.113h-3.226l-.232,3.288H127.985v6.726h-3.328l-.226-3.16-3.195-.273-.3-3.184h-3.155V309.51l3.223.364v3.155l-3.163.383v3.218l3.331.2.022,3.5h-3.432v6.86h-6.95v-3.357l3.223-.346v-3.128h-3.209l-.363,3.2-3.143.249-.4,3.154c-1.3.142-2.493.273-3.682.4.159-2.291.318-4.582.483-6.956H89.9v3.269h10.325l-.38,3.272H89.915v10.606c1.268-.115,2.366-.214,3.456-.3v7.036l-3.5.383v3.175H93.1l.246-3.422h6.615v-3.286l-3.143-.347-.347-3.163-3.15-.313v-6.584h3.223l.29,3.2h3.4c-.145-2.413-.283-4.714-.413-7.008l3.457.417.549,6.546,3.125.319v3.147l-3.209.359v6.714l3.2-.141q0,1.992.007,3.982H96.791v3.038h10.352l-.243-3.083h3.99l-.188,3.105h3.324v-3.308l-3.19.259.006-3.993H117.5c.128-2.473.244-4.715.355-6.952l-.083.078,3.177.23.331,3.183,3.159.349v3.151l-3.208.332-.242,3.161-3.195.392v6.615h3.416v-6.819l3.242.143c.107,1.287.186,2.232.289,3.467h6.6v3.433h-6.617v6.9h3.309Q128.039,363.69,128.041,365.434Zm-14.073-48.825V292.5H89.949v24.106Zm38.572-.023h24v-24.1h-24ZM114.03,355.216H89.905v23.9H114.03Zm10.426-62.749H117.8v3.144h6.652Zm21.1,24.061h3.264v-3.146h-3.264Zm3.231-20.891V292.5H145.67v3.136Z",
    transform: "translate(-84.374 -286.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32574",
    "data-name": "Path 32574",
    d: "M178.97,333.155c-.073.965-.146,1.93-.235,3.1l3.353.3.3,3.309h6.641c.079,1.2.142,2.153.223,3.384h6.668v6.848l-3.109.374c-.146,1.067-.276,2.017-.4,2.973-2.15.178-4.305.349-6.577.53v3.177h6.859l-.333-3.771,3.623.682V367.6l-3.206.329c-.092,1.107-.184,2.206-.272,3.306-1.031,0-2.064,0-3.228,0l-.228-3.288H182.4v10.04h3.236c.06-1.115.11-2.066.175-3.268h6.862c-.1-1.374-.172-2.473-.248-3.573l3.527.2v6.693l-3.148.213c-.1,1.048-.2,2.063-.319,3.22l-3.118.234v3.322h6.574v3.326H172c-.072-.978-.142-1.926-.228-3.082l-3.221-.355-.338-3.183h-3.127l-.407,3.181-3.116.283-.427,3.2H144.172c-.108-1.013-.217-2.027-.34-3.178h-3.119l-.313,3.158h-3.187V374.829h3.225v6.755h7.025l-.055-.058v3.348h6.923v-3.346l-.059.059h3.489V378.1l-.06.059h3.673c-.126,1.277-.226,2.287-.321,3.3-1,.115-2.009.225-3.037.337v3.084h3.426l-.459-3.494,3.657.254.439-3.344,3.173-.325v-3.118l-3.423-.365V360.806c-2.941.608-3.971-.687-3.539-3.638-1.457.237-2.607.424-3.753.606.173-1.258.343-2.512.516-3.794h3.134l.294,3.174h3.235c.117-1.126.221-2.137.324-3.133,1.3-.221,2.482-.42,3.657-.616-.123,1.193-.242,2.381-.374,3.7h13.806v-3.35c-1.33,0-2.539.026-3.745,0-3.246-.083-6.491-.189-9.736-.286l-.513-3.059-3.148-.316c-.1-1.161-.19-2.116-.3-3.383h-10.2c-.1-1.281-.175-2.233-.251-3.188h-3.468c0,2.293,0,4.4,0,6.515-1.019.144-2.042.283-3.189.439v6.678h3.13v-7.191l3.7.589v6.419l3.154.773v9.894l-3.08.33c-.113,1.163-.211,2.167-.318,3.268h-3.328l.06.06v-3.306h-3.492v3.307l.057-.06h-3.309v-6.9h6.617V360.9h-6.6c-.1-1.234-.182-2.179-.289-3.467l-3.242-.143v6.819h-3.416V357.5l3.195-.392.242-3.161,3.208-.333v-3.151l-3.159-.349-.331-3.183c-1.108-.08-2.143-.155-3.18-.227q-.149-1.621-.291-3.246c-1.141-.1-2.089-.19-3.042-.271-.177-1.066-.348-2.137-.515-3.177h-3.118v3.372l3.7-.249-.4,3.716,3.754-.229-.361,6.957h-6.663l.039.047-.463-3.2h-3.121l-.4,3.2.039-.047-3.2.141V347l3.209-.359V343.5l-3.125-.319-.549-6.546-.038.029,3.686-.4.4-3.154,3.143-.249.363-3.2h3.209v3.128l-3.223.346v3.357h6.95l-.075-.068v3.336l3.277.309.321,3.189,3.118.234c.115,1.155.216,2.165.313,3.139h3.425v-6.834h10.3c-.074-1.284-.135-2.328-.2-3.373h3.483c.133,1.371.226,2.327.321,3.314h3.2v-6.672h-7.011V322.71H154.5c-.128,1.19-.234,2.19-.339,3.171l-3.334.321v-7.047h-6.735v3.164l3.379.4V326.2l-3.493-.085.06.063v-3.5h-3.493v3.5l.055-.057-3.331-.2V322.7l3.163-.383v-3.155l-3.223-.364V308.665h3.155l.3,3.184,3.195.273.226,3.16h3.328v-6.726h10.294l.232-3.288h3.226l.294,3.113h6.7v10.461h-6.617v10.644h10.181v6.745l-3.188.331-.291,3.162-3.166.278v6.629h6.649c.1-1.053.2-2.066.3-3.147,1.247-.117,2.369-.223,3.489-.326,0,1.176,0,2.349,0,3.437h3.155v-3.151l-3.227-.2v-10.3c1.272.1,2.435.19,3.593.277Zm-.34,37.993V361H168.571v10.144Zm7.225-24.317-.313-3.375h-3.168v10.153h3.181c.125-1.155.235-2.161.374-3.446h6.549v-3.332ZM157.7,312.13h-6.659v6.7H157.7Zm24.663,52.039h10.105V361H182.36ZM129.877,339.8v-3.249H126.7V339.8Zm55.778,41.973h-3.231v3.1h3.231Zm-7.051-3.707V374.82h-3.115v3.243Zm-3.067,3.642v3.239h3.1V381.7Zm-21.367-21.01v-3.411l-3.114.183v3.228Zm-23.95-10.384,3.412-.184-.151-3.143H130.22Z",
    transform: "translate(-103.801 -296.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32575",
    "data-name": "Path 32575",
    d: "M119.709,322.317H95.69V298.211h24.019Zm-3.434-20.643H99.068v17.1h17.207Z",
    transform: "translate(-90.115 -292.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32576",
    "data-name": "Path 32576",
    d: "M222.747,322.28v-24.1h24v24.1Zm3.5-20.683v17.115h17.033V301.6Z",
    transform: "translate(-154.581 -292.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32577",
    "data-name": "Path 32577",
    d: "M119.726,425.512v23.9H95.6v-23.9Zm-3.464,3.467H99.07v16.912h17.193Z",
    transform: "translate(-90.071 -357.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32578",
    "data-name": "Path 32578",
    d: "M99.087,378.4l-3.465.314V368.107c3.334,0,6.631,0,9.936.005.007.005-.042-.041-.042-.041.138,2.3.276,4.6.422,7.016h-3.4l-.29-3.2H99.026v6.584Z",
    transform: "translate(-90.081 -328.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32579",
    "data-name": "Path 32579",
    d: "M108.965,361.8q-1.728-.209-3.461-.421s.044.043.037.037c.109-1.009.226-2.014.372-3.277H95.589v-3.269h13.825c-.165,2.374-.324,4.665-.485,6.957Z",
    transform: "translate(-90.064 -321.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32580",
    "data-name": "Path 32580",
    d: "M98.982,389.114l3.15.313.347,3.163,3.143.347v3.286H99.007l-.246,3.422H95.536V396.47l3.5-.383c0-2.352,0-4.694,0-7.041Z",
    transform: "translate(-90.037 -338.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32581",
    "data-name": "Path 32581",
    d: "M172.946,452.836q0-1.745.008-3.491l-.062.063h3.49v-3.491l-.061.061,6.664-.244-.023-.032.22,3.708.06-.059-3.309.19-.18,3.3.059-.059-6.923,0Z",
    transform: "translate(-129.285 -367.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32582",
    "data-name": "Path 32582",
    d: "M152.075,361.485v-6.86h3.432l-.076-.071v3.338l3.28.184v3.341H152Z",
    transform: "translate(-118.686 -321.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32583",
    "data-name": "Path 32583",
    d: "M246.673,358.358q-4.99-.023-9.975-.041l.065.072c-.1-1.1-.194-2.207-.31-3.518h10.474c-.1,1.219-.2,2.378-.3,3.535Z",
    transform: "translate(-161.535 -321.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32584",
    "data-name": "Path 32584",
    d: "M119.688,411.323l.243,3.082H109.58v-3.038h10.154Z",
    transform: "translate(-97.163 -350.059)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32585",
    "data-name": "Path 32585",
    d: "M158.886,298.136v3.145h-6.652v-3.145Z",
    transform: "translate(-118.804 -292.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32586",
    "data-name": "Path 32586",
    d: "M134.039,403.329l-.006,3.993.055-.055H130.1l.045.045q0-1.991-.007-3.982l-.039.047h3.983Z",
    transform: "translate(-107.572 -346.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32587",
    "data-name": "Path 32587",
    d: "M208.569,343.739v-3.146h3.264v3.146Z",
    transform: "translate(-147.387 -314.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32588",
    "data-name": "Path 32588",
    d: "M260.581,361.261c.1,1.083.2,2.166.315,3.416h-3.332c-.139-1.073-.27-2.079-.405-3.08,0,0-.048.049-.05.051q1.771-.16,3.546-.324Z",
    transform: "translate(-172.015 -324.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32589",
    "data-name": "Path 32589",
    d: "M264.235,358.041l.351-3.249h3.1v3.195c-1.148,0-2.334,0-3.523,0Z",
    transform: "translate(-175.596 -321.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32590",
    "data-name": "Path 32590",
    d: "M172.953,442.66q0-1.744,0-3.489l-.057.06h3.492l-.06-.06v3.493l.061-.061h-3.49Z",
    transform: "translate(-129.286 -364.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32591",
    "data-name": "Path 32591",
    d: "M169.616,449.566h-3.305V446.2h3.3l-.06-.058v3.492Z",
    transform: "translate(-125.947 -367.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32592",
    "data-name": "Path 32592",
    d: "M159.04,351.091q-.01-1.75-.022-3.5l-.055.057,3.493,0-.06-.063v3.431h-3.432Z",
    transform: "translate(-122.219 -317.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32593",
    "data-name": "Path 32593",
    d: "M211.917,301.343H208.8v-3.136h3.117Z",
    transform: "translate(-147.504 -292.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32594",
    "data-name": "Path 32594",
    d: "M137.95,411.167l3.19-.259v3.308h-3.324c.066-1.084.127-2.095.188-3.1Z",
    transform: "translate(-111.489 -349.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32595",
    "data-name": "Path 32595",
    d: "M155.431,347.512h3.432v-3.431l3.493.085-.071-.089.206,3.244h3.3v-3.247l-.08.092,3.334-.321c.1-.981.212-1.98.339-3.171h3.172v10.342l.093-.083H169.39v3.344l3.258.164-.085-.067c.061,1.044.121,2.088.2,3.373h-10.3v6.834h-3.425c-.1-.974-.2-1.984-.313-3.139l-3.118-.234-.321-3.189L152,357.711v-3.335h6.712v-3.341l-3.28-.184Z",
    transform: "translate(-118.686 -314.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32596",
    "data-name": "Path 32596",
    d: "M179.856,428.179v-3.493h3.328c.107-1.1.205-2.105.318-3.268l3.08-.33v-9.894l-.033.04,3.756-.611c-.432,2.95.6,4.246,3.539,3.638v13.681l3.423.364v3.118l-3.173.325-.439,3.344L190,434.839l.065.068c.1-1.01.2-2.019.326-3.3h-3.673q-.11-1.854-.218-3.706c1.228.081,2.454.16,3.621.234v-3.3h-3.027l-.573,3.1Z",
    transform: "translate(-132.819 -349.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32597",
    "data-name": "Path 32597",
    d: "M186.448,397.133l-3.154-.773V389.94l-3.7-.589.054.069v-6.51h3.468c.075.956.15,1.907.251,3.188h10.2c.114,1.267.2,2.223.3,3.383l3.148.316.513,3.059.053-.061-3.66.619c-.1,1-.207,2.007-.324,3.133h-3.235l-.294-3.173h-3.134c-.173,1.281-.343,2.536-.516,3.794Z",
    transform: "translate(-132.684 -335.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32598",
    "data-name": "Path 32598",
    d: "M225.911,428.553H215.853V418.409h10.058Zm-6.615-3.531h3.151v-3.1H219.3Z",
    transform: "translate(-151.083 -353.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32599",
    "data-name": "Path 32599",
    d: "M253.945,435.7c.076,1.1.153,2.2.248,3.574h-6.862c-.064,1.2-.115,2.153-.175,3.268H243.92V432.5h6.652c.07,1.016.14,2.025.228,3.288,1.164,0,2.2,0,3.228,0Z",
    transform: "translate(-165.323 -360.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32600",
    "data-name": "Path 32600",
    d: "M247.35,386.162h6.623v3.332h-6.549c-.139,1.285-.249,2.291-.374,3.446h-3.181V382.787h3.168Z",
    transform: "translate(-165.297 -335.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32601",
    "data-name": "Path 32601",
    d: "M215.673,403.042c3.245.1,6.49.2,9.736.286,1.207.03,2.416,0,3.745,0v3.35H215.348c.133-1.318.252-2.507.374-3.7Z",
    transform: "translate(-150.827 -345.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32602",
    "data-name": "Path 32602",
    d: "M186.919,319.2v6.7H180.26v-6.7Z",
    transform: "translate(-133.024 -303.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32603",
    "data-name": "Path 32603",
    d: "M193.731,361.584h7.011v6.672h-3.2c-.1-.987-.188-1.943-.321-3.314h-3.483l.085.067q0-1.754,0-3.507Z",
    transform: "translate(-139.859 -324.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32604",
    "data-name": "Path 32604",
    d: "M169.543,340.5v-3.478l-3.379-.4v-3.164H172.9V340.5l.08-.092-3.507,0Z",
    transform: "translate(-125.872 -310.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32605",
    "data-name": "Path 32605",
    d: "M243.842,421.566v-3.172h10.105v3.172Z",
    transform: "translate(-165.284 -353.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32606",
    "data-name": "Path 32606",
    d: "M257.423,402.925l.333,3.771H250.9v-3.177c2.272-.181,4.427-.352,6.577-.53Z",
    transform: "translate(-168.863 -345.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32607",
    "data-name": "Path 32607",
    d: "M176.365,395.984v7.191h-3.13V396.5c1.146-.156,2.17-.295,3.189-.439Z",
    transform: "translate(-129.46 -342.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32608",
    "data-name": "Path 32608",
    d: "M172.891,460.068l6.923,0v3.346h-6.923Z",
    transform: "translate(-129.285 -374.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32609",
    "data-name": "Path 32609",
    d: "M134.079,400.126H130.1c.127-1.022.255-2.043.4-3.2h3.121Z",
    transform: "translate(-107.572 -342.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32610",
    "data-name": "Path 32610",
    d: "M134.032,372.012h-3.179v-3.249h3.179Z",
    transform: "translate(-107.956 -328.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32611",
    "data-name": "Path 32611",
    d: "M247.2,460.561v3.105h-3.231v-3.105Z",
    transform: "translate(-165.35 -375.041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32612",
    "data-name": "Path 32612",
    d: "M229.789,382.264l3.227.2v3.151h-3.155c0-1.087,0-2.261,0-3.437Z",
    transform: "translate(-158.154 -335.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32613",
    "data-name": "Path 32613",
    d: "M145.074,382.177l3.036.277q.144,1.623.291,3.246l.089-.083c-1.112.066-2.227.134-3.751.227l.4-3.715Z",
    transform: "translate(-115.002 -335.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32614",
    "data-name": "Path 32614",
    d: "M141.736,378.912l-3.7.249v-3.372h3.118c.167,1.04.337,2.111.515,3.177Z",
    transform: "translate(-111.599 -332.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32615",
    "data-name": "Path 32615",
    d: "M176.384,435.887h-3.492v-3.308h3.492Z",
    transform: "translate(-129.286 -360.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32616",
    "data-name": "Path 32616",
    d: "M233.01,449.7h-3.115v-3.242h3.115Z",
    transform: "translate(-158.207 -367.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32617",
    "data-name": "Path 32617",
    d: "M186.824,456.6l.18-3.3,3.308-.19v3.49Z",
    transform: "translate(-136.354 -371.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32618",
    "data-name": "Path 32618",
    d: "M162.457,344.108l-3.493,0v-3.5h3.493Z",
    transform: "translate(-122.219 -314.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32619",
    "data-name": "Path 32619",
    d: "M229.993,460.428h3.1v3.239h-3.1Z",
    transform: "translate(-158.257 -374.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32620",
    "data-name": "Path 32620",
    d: "M183.411,414.267H180.3v-3.228l3.114-.183Z",
    transform: "translate(-133.043 -349.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32621",
    "data-name": "Path 32621",
    d: "M197.393,459.781l.459,3.494h-3.426V460.19c1.027-.112,2.034-.223,3.037-.337Z",
    transform: "translate(-140.211 -374.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32622",
    "data-name": "Path 32622",
    d: "M138,393.275v-3.327h3.261l.151,3.144Z",
    transform: "translate(-111.584 -339.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32623",
    "data-name": "Path 32623",
    d: "M119.755,305.24v17.1H102.548v-17.1Zm-13.715,3.392v10.151h10.122V308.632Z",
    transform: "translate(-93.595 -296.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32624",
    "data-name": "Path 32624",
    d: "M229.846,305.112h17.033v17.115H229.846Zm13.553,3.476H233.318v10.136H243.4Z",
    transform: "translate(-158.182 -296.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32625",
    "data-name": "Path 32625",
    d: "M119.835,432.549v16.912H102.642V432.549Zm-3.585,3.416H106.09v10.07H116.25Z",
    transform: "translate(-93.643 -360.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32626",
    "data-name": "Path 32626",
    d: "M172.894,449.629v-3.492h3.49v3.491Z",
    transform: "translate(-129.287 -367.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32627",
    "data-name": "Path 32627",
    d: "M190.562,361.5q0,1.754,0,3.507l-3.258-.164V361.5Z",
    transform: "translate(-136.596 -324.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32628",
    "data-name": "Path 32628",
    d: "M172.878,347.579l3.507,0v3.247h-3.3Z",
    transform: "translate(-129.279 -317.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32629",
    "data-name": "Path 32629",
    d: "M193.363,442.572l.573-3.1h3.027v3.3c-1.167-.075-2.393-.154-3.621-.234Z",
    transform: "translate(-139.661 -364.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32630",
    "data-name": "Path 32630",
    d: "M222.842,428.637v-3.1h3.151v3.1Z",
    transform: "translate(-154.629 -357.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32631",
    "data-name": "Path 32631",
    d: "M109.637,312.126h10.123v10.151H109.637Z",
    transform: "translate(-97.192 -299.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32632",
    "data-name": "Path 32632",
    d: "M246.976,312.169V322.3H236.9V312.169Z",
    transform: "translate(-161.759 -299.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32633",
    "data-name": "Path 32633",
    d: "M119.8,439.483v10.07H109.642v-10.07Z",
    transform: "translate(-97.194 -364.347)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.b1cc6e919a7fd326cb422f5df03c0c77.svg";
export { ForwardRef as ReactComponent };